import { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Loader} from 'semantic-ui-react'
import axios from "../../axios";
import { axiosWC } from "../../axios";

export default function TestimonialsModal(props) {
    const [testimonials, setTestimonials] = useState();
    const [hasMore, setHasMore] = useState(true);
    const [currPage, setCurrpage] = useState(1);
    
    useEffect(() => {
        fetchData();
    }, [])

    async function fetchData() {
        await axiosWC.get(`/courses/${props.courseSlug}/testimonials/`, {
            params : {
                page : currPage,
                view_more : true
            }
        }).then((res) => {
            if (!testimonials)
                setTestimonials(res.data.testimonials.results)
            else
                setTestimonials([...testimonials, ...res.data.testimonials.results]);
            setHasMore(res.data.testimonials.results.length)
            setCurrpage(currPage + 1)
        }).catch((err) => {
            console.log(err)
        })
    }
    
    if (!testimonials)
        return (<div style={{height:"60vh"}}><Loader active/></div>)
    if (testimonials.length === 0)
        return <p> Nothing to load</p>    
    return (
        <section>
            <InfiniteScroll
                dataLength={testimonials.length}
                next={() => {fetchData()}}
                height={'60vh'} 
                hasMore={!!hasMore}
                loader = { <div className="infiniteScrollLoader">
                    <Loader active inline/>
                </div>}
                endMessage={
                    <p className = "mt-3" style={{ textAlign: 'center' }}>
                        <b>No more testimonials to load</b>
                    </p>
                }
            >
                {
                    testimonials.map((comment, index) => {
                        return (
                            <div className="shadow-sm card mt-3 setReviewCardBorder" key = {index}>
                                <div className = "row pl-3 pr-0 pt-2">
                                    <div className = "pl-3 alignNameDesig">
                                        <img className = "rounded-circle img-fluid testimonial-image" src = {comment.img_url} style={{
                                            width: '3rem',height: '3rem'}}></img>        
                                    </div>
                                    <div className = "pl-3 text-left alignNameDesig">
                                        <div className="h5 sofia-pro mb-1 heading" dangerouslySetInnerHTML={{ __html: comment.handle }}></div>
                                        <div className="text-success sofia-pro" dangerouslySetInnerHTML={{ __html: comment.achievements }}></div>
                                    </div>
                                </div>
                                <div className="card-body pt-3">
                                    <div className="card-text text-left text-muted urw-din" dangerouslySetInnerHTML={{ __html: comment.modified_data }}></div>
                                </div>
                            </div> 
                        )
                    })
                }
            </InfiniteScroll>
        </section>
    )
}
